import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';
import { ModalController } from '@ionic/angular/standalone';
import { ImageCropperComponent, } from 'ngx-image-cropper';
import { TranslateModule } from '@ngx-translate/core';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonTitle, IonToolbar } from "@ionic/angular/standalone";
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';

@Component({
    selector: 'app-img-cropper',
    templateUrl: './img-cropper.component.html',
    styleUrls: ['./img-cropper.component.scss'],
    standalone: true,
    imports: [
      IonHeader,
      IonToolbar,
      IonButtons, IonButton, IonIcon, IonContent,
      IonTitle, IonFooter,
      ImageCropperComponent,
      TranslateModule,
    ],
})
export class ImgCropperComponent  implements OnInit {
  @ViewChild('cropper') cropper: ImageCropperComponent;

  @Input() image;

  imageChangedEvent: any = '';
  croppedImage: any = '';

  isMobile = Capacitor.getPlatform() !== 'web';

  constructor(
    private sanitizer: DomSanitizer,
    private modalController: ModalController
  ) {
    addIcons({ close })
  }

  ngOnInit(): void {

  }

  cropperReady() {
      // cropper ready
  }
  loadImageFailed() {
      // show message
  }

  dismissModal() {
    this.modalController.dismiss(null, 'cancel');
  }

  cropImage() {
    this.cropper.crop();
  }

  imageCropped($event: any) {
    this.modalController.dismiss($event.objectUrl, 'confirm');
  }
}
